<template>
  <el-dialog title="工人考勤" :visible.sync="dialogVisible" v-loading="loading" :before-close="handleClose"
    :width.sync='dialogWidth'>
    <div class="content">
      <div class="base_info">
        <div class="left">
          <span class="label">工人姓名：</span>
          <span class="value">{{ info.workerName }}</span>
        </div>
        <div class="right">
          <span class="label">签到项目：</span>
          <span class="value">{{ info.projectName }}</span>
        </div>
      </div>
      <div class="attendance_info">
        <div class="sing">
          <div class="title">签到信息</div>
          <div class="sing_info">
            <div class="item" v-if="info?.onSignRecord?.signId">
              <div class="img">
                <!-- <img :src="info.onSignRecord.signImage" alt="" srcset=""> -->
                <el-image :src="info.onSignRecord.signImage" :preview-src-list="[info.onSignRecord.signImage]"
                  fit="fill" ref="preview">
                </el-image>
              </div>
              <div class="con">
                <div class="label">
                  <div class="sign_img"><img :src='imgSrc(info?.onSignRecord?.resignFlag)'></div>
                  上班签到：
                </div>
                <span class="value">{{ info.onSignRecord.signTime }}</span>
              </div>
              <div class="con">
                <div class="label">
                  <div class="sign_img"><img src="@/assets/img/attendance/sign_address.svg"></div>
                  签到地点：
                </div>
                <span class="value">{{ info.onSignRecord.signAddress }}</span>
              </div>
            </div>
            <div class="item" v-else>
              <div class="img"><img src="@/assets/img/empty.svg" /></div>
              <div class="con">
                <div class="label">
                  <div class="sign_img"><img src="@/assets/img/attendance/sign.svg"></div>
                  下班签到：
                </div>
                <span class="value">--</span>
              </div>

              <div class="con">
                <div class="label">
                  <div class="sign_img"><img src="@/assets/img/attendance/sign_address.svg"></div>
                  签到地点：
                </div>
                <span class="value">
                  --
                </span>
              </div>
            </div>
            <div class="item" v-if="info?.offSignRecord?.signId">
              <div class="img">
                <el-image :src="info.offSignRecord.signImage" :preview-src-list="[info.offSignRecord.signImage]"
                  fit="fill" ref="preview">
                </el-image>
              </div>
              <div class="con">
                <div class="label">
                  <div class="sign_img"><img :src='imgSrc(info?.offSignRecord?.resignFlag)'></div>
                  下班签到：
                </div>
                <span class="value">{{ info.offSignRecord.signTime }}</span>
              </div>

              <div class="con">
                <div class="label">
                  <div class="sign_img"><img src="@/assets/img/attendance/sign_address.svg"></div>
                  签到地点：
                </div>
                <!-- <el-tooltip class="item" effect="dark" content="Bottom Center 提示文字" placement="bottom"> -->
                <span class="value">
                  {{ info.offSignRecord.signAddress }}
                </span>
                <!-- </el-tooltip> -->
              </div>
            </div>
            <div class="item" v-else>
              <div class="img"><img src="@/assets/img/empty.svg" /></div>
              <div class="con">
                <div class="label">
                  <div class="sign_img"><img src="@/assets/img/attendance/sign.svg"></div>
                  下班签到：
                </div>
                <span class="value">--</span>
              </div>

              <div class="con">
                <div class="label">
                  <div class="sign_img"><img src="@/assets/img/attendance/sign_address.svg"></div>
                  签到地点：
                </div>
                <!-- <el-tooltip class="item" effect="dark" content="Bottom Center 提示文字" placement="bottom"> -->
                <span class="value">
                  --
                </span>
                <!-- </el-tooltip> -->
              </div>
            </div>
          </div>
        </div>
        <div class="overTime" v-if="info?.overtimeRecords?.length">
          <div class="title">加班信息</div>
          <div class="overTime_info">
            <div class="item" v-for="(item, index) in info.overtimeRecords" :key="index">
              <!-- <div class="img"></div> -->
              <div class="img" v-if="item.fileList.length">
                <div class="imgBlock" v-for="(itemImg, imgIndex) in item.fileList" :key="imgIndex">
                  <el-image :src="itemImg.filePrefix + itemImg.fileUrl"
                    :preview-src-list="item.fileList | imgListFormat" fit="fill" ref="preview">
                  </el-image>
                </div>
              </div>
              <div v-else class="empty">暂无图片！</div>
              <div class="con">
                <div class="label">
                  <div class="sign_img"><img src="@/assets/img/attendance/work_overtime.svg"></div>
                  加班时长：
                </div>
                <span class="value">{{ item.overtimeHours }}</span>
              </div>
              <div class="con">
                <div class="label">
                  <div class="sign_img"><img src="@/assets/img/attendance/workovertime_remark.svg"></div>
                  加班备注：
                </div>
                <span class="value">{{ item.remark }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'WorkerDetails',
  props: {
    id: {
      type: String,
      default: ''
    },
    detailsShow: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      dialogVisible: false,
      loading: false,
      dialogWidth: '',

      info: {
        // 基础信息
        workerName: '',
        signProjectName: '',
        onSignRecord: {},
        offSignRecord: {},
        overtimeRecords: []
      }
    }
  },
  filters: {
    imgListFormat (list) {
      const imgList = list.map(item => {
        return item.filePrefix + item.fileUrl
      })
      return imgList || []
    }
  },
  watch: {
    detailsShow (val) {
      this.dialogVisible = val
      val && this.getDetail()
    }
  },
  methods: {
    getDetail () {
      // this.loading = true
      this.$axios.get(this.$apis.laborManage.selectYhSingleAttendanceDetail, { attendanceId: this.id }).then(res => {
        if (res) {
          this.info = res
        }
      }).finally(() => {
        // this.loading = false
        if (this.info.overtimeRecords.length) {
          this.dialogWidth = '761px'
        } else {
          this.dialogWidth = '517px'
        }
      })
    },

    handleClose () {
      // console.log('关闭弹窗')
      this.$emit('update:detailsShow', false)
      this.info = {
        workerName: '',
        signProjectName: '',
        onSignRecord: {},
        offSignRecord: {},
        overtimeRecords: []
      }
    },

    imgSrc (val) {
      // console.log('图片处理', val)
      if (val) {
        if (val === 'Y') {
          return require('@/assets/img/attendance/card_replacement.svg')
        } else {
          return require('@/assets/img/attendance/sign.svg')
        }
      }
    }
  }

}
</script>

<style scoped lang="scss">
::v-deep .el-dialog {
  border-radius: 10px;
  // width: 761px;
  // height: 510px;
}

.content {
  padding: 10px;
  font-size: 14px;

  .base_info {
    line-height: 30px;
    display: flex;

    .left,
    .right {
      display: flex;

      .label {
        width: 80px;
      }

      .value {
        flex: 1;
      }
    }

    .left {
      width: 200px;
    }

    .right {
      flex: 1;
    }

  }

  .attendance_info {
    display: flex;
    min-height: 300px;
    overflow-x: auto;

    .title {
      line-height: 50px;
    }

    .sing {
      width: 457px;

      .signbox {
        display: flex;
        justify-content: space-between
      }
    }

    .overTime {
      flex: 1;
      margin-left: 29px;

      .overTime_info {
        display: flex;

        .item {
          margin-right: 30px;
        }

        .item:last-child {
          margin-right: 0;
        }
      }

    }

    .sing_info {
      width: 457px;
      display: flex;
      justify-content: space-between;
    }

    .item {
      width: 214px;
      min-height: 300px;
      font-size: 12px;

      .img {
        width: 214px;
        height: 214px;
        margin-bottom: 12px;
        overflow: hidden;

        .imgBlock {
          width: 100%;
          height: 100%;
        }

        img {
          width: 100%;
          height: 100%;
        }

      }

      .con {
        display: flex;
        padding: 0 5px;
        line-height: 20px;

        .label {
          width: 85px;
          line-height: 30px;
          height: 30px;
          display: flex;
          align-items: center;

          .sign_img {
            width: 20px;
            justify-content: center;
            display: flex;
            align-items: center;
            margin-right: 5px;
            // height: 20px;
          }
        }

        .value {
          flex: 1;
          line-height: 30px;
        }
      }
    }
  }
}

// .smallWidth{
//   width: 500px !important;
// }</style>
